import { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { PATHS } from 'src/common/constants';
import {
  FetchAnnouncementByIdResult,
  useAnnouncementsAPI,
  UseAnnouncementsAPIReturn,
} from 'src/pages/Announcements/CustomHooks/useAnnouncementsAPI';
import { SidebarContextRow } from '../Components/SidebarContextTree';

interface RouteParams {
  id: string;
}

const useAnnouncementContextRows = (): SidebarContextRow[] | null => {
  const match = useRouteMatch<RouteParams>({ path: PATHS.ANNOUNCEMENTS_VIEW });
  const announcementId: string = match?.params?.id ?? '';

  const { fetchAnnouncementById }: UseAnnouncementsAPIReturn =
    useAnnouncementsAPI();

  const [announcement, setAnnouncement] = useState<any>(null);

  useEffect(() => {
    if (!announcementId) {
      return;
    }

    let active: boolean = true;

    const loadAnnouncement = async () => {
      const result: FetchAnnouncementByIdResult =
        await fetchAnnouncementById(announcementId);

      if (active && result.ok) {
        setAnnouncement(result.data);
      }
    };

    void loadAnnouncement();

    return () => {
      active = false;
    };
  }, [announcementId]);

  if (!match || !announcementId) {
    return null;
  }

  return [
    {
      label: announcement?.title ?? '',
      path: PATHS.ANNOUNCEMENTS_VIEW.replace(':id', announcementId),
      icon: 'bullhorn',
      loading: !announcement,
    },
  ];
};

export default useAnnouncementContextRows;
